import { FaDiscord, FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const ContactData = {
  phone: "+91 9515643851",
  email: "sanjanamutkirir@gmail.com",
  address: "Solapur , Maharastra , India",
  links: [
    {
      url: "https://github.com/sanjanamutkiri",
      icon: FaGithub,
    },
    {
      url: "https://www.linkedin.com/in/sanjana-mutkiri-711681259",
      icon: FaLinkedin,
    },
    {
      url: "https://leetcode.com/u/sanjana_mutkiri/",
      icon: FaDiscord,
    },
    {
      url: "https://www.instagram.com/sanjana_mutkiri_0610?igsh=eTR5MWV6MTR1NDdq",
      icon: FaInstagram,
    },
    {
      url: "https://sanjanamutkiri.github.io/MyPortfolio/Resume",
      icon: FaXTwitter,
    },
  ],
};

export default ContactData;
